import { Title, TitleMarkup } from '@bytel/trilogy-react-ts';

import { FaiProduct } from '@app-types/fai';
import { JOURNEYS, PlanType } from '@app-types/product';

import HomeDivider from '@components/layout/home-divider';

import { BAndyouConfigurator, BboxConfigurator } from '@landing/components';
import { useHome } from '@landing/hooks';

type HomePageConfiguratorsProps = {
    plans: PlanType[];
    faiProducts: FaiProduct[];
    featureFaiBlockActivated: boolean;
    repeaterPrice?: number;
};
export default function HomePageConfigurators({
    plans,
    faiProducts,
    featureFaiBlockActivated,
    repeaterPrice,
}: HomePageConfiguratorsProps) {
    const { otisConfigurator } = useHome();
    const isMobileFirst = otisConfigurator.value === JOURNEYS.BYOU;

    return isMobileFirst ? (
        <>
            <BAndyouConfigurator plans={plans} />
            {featureFaiBlockActivated && (
                <>
                    <HomeDivider />
                    <Title markup={TitleMarkup.H2}>Et si vous ajoutiez une offre fibre sans engagement&nbsp;?</Title>
                    <BboxConfigurator faiProducts={faiProducts} repeaterPrice={repeaterPrice} />
                </>
            )}
        </>
    ) : (
        <>
            <BboxConfigurator faiProducts={faiProducts} repeaterPrice={repeaterPrice} />
            <HomeDivider />
            <Title markup={TitleMarkup.H2}>Et si vous ajoutiez un forfait sans engagement&nbsp;?</Title>
            <BAndyouConfigurator plans={plans} />
        </>
    );
}
